import FormInput from "../common/components/FormInput";
import {API, Notifications, Steps} from "../common/constants/constants";
import {GeneralDataInterface} from "../common/interfaces/GeneralDataInterface";
import {LocationDataInterface} from "../common/interfaces/LocationDataInterface";
import {FieldInterface} from "../common/interfaces/FieldInterface";
import {generalFields} from "../common/constants/generalFields";
import {locationFields} from "../common/constants/locationFields";
import {SpacewellPolicy} from "../common/components/SpacewellPolicy";
import {Buttons} from "../common/components/Buttons";
import {mapLocationKeysToFilterData} from "../common/utils/mapLocationKeysToFilterData";
import {PopupInterface} from "../common/interfaces/PopupInterface";
import {completeReportResult} from "../common/api/axxerion";

interface Props {
    step: string
    setStep: (step: string) => void
    setGeneralData: (data: GeneralDataInterface) => void
    generalData: GeneralDataInterface
    setLocationData: (data: LocationDataInterface) => void
    locationData: LocationDataInterface
    setLoading: (loading: boolean) => void,
    popupData: PopupInterface,
    setPopupData: (data: PopupInterface) => void
}

const LocationView = (props: Props) => {

    const {step, setStep, generalData, setGeneralData, locationData, setLocationData} = props
    const locationFieldsDisabled = step !== Steps.LOCATION
    const showNextButton = locationData.address && locationData.number && locationData.approveSpaceWell

    if (step === Steps.CONFIRMED) {
        return null
    }

    return (
        <form onSubmit={(event) => {
            event.preventDefault()
            submitForm(props)
        }}>

            <h2 className="p-repair-form__title">Algemeen</h2>

            {generalFields(generalData, setGeneralData).map((field: FieldInterface) => {
                return <FormInput {...field} />
            })}

            <h2 className="p-repair-form__title">Locatiegegevens</h2>

            {locationFields({
                locationData,
                setLocationData,
                disabled: locationFieldsDisabled,
                step: step
            }).map((field: FieldInterface) => {
                return <FormInput {...field} />
            })}

            <SpacewellPolicy
                locationData={locationData}
                setLocationData={setLocationData}
                locationFieldsDisabled={locationFieldsDisabled}
            />

            <Buttons
                hide={locationFieldsDisabled}
                nextButton={{
                    text: 'volgende',
                    disabled: !showNextButton
                }}
            />

        </form>
    )
}

const submitForm = async (props: Props) => {

    const {
        locationData,
        setLoading,
        setGeneralData,
        generalData,
        setStep, setPopupData, popupData,
        setLocationData
    } = props

    setLoading(true)

    const allowSubmit = locationData.address && locationData.number && locationData.approveSpaceWell

    if (!allowSubmit) {
        return
    }

    const filterData = mapLocationKeysToFilterData(locationData)
    const {filterFields, filterValues} = filterData

    const data = await completeReportResult(
        {
            "reference": API.COMPLETE_RESULT_REFERENCE,
            "filterFields": filterFields,
            "filterValues": filterValues,
        }
    )

    console.log(data)

    switch (Array.isArray(data) && data.length) {
        case(0):
            setPopupData({
                isActive: true,
                message: Notifications.NO_ADDRESS,
                title: 'Attentie'
            })
            break
        case(1):

            const dataObject = data[0]

            setGeneralData({
                ...generalData,
                apiReference: dataObject?.Referentie,
            })

            setLocationData({
                ...locationData,
                postalCode: dataObject?.Postcode,
                city: dataObject?.Stad
            })

            setStep(Steps.REPORT_DATA)
            break

        default:
            setPopupData({
                isActive: true,
                message: Notifications.ADD_ADDRESS_DATA,
                title: 'Attentie'
            })
    }

    setLoading(false)

    return true
}

export default LocationView